import { render, staticRenderFns } from "./GideViewCurrentEvent.vue?vue&type=template&id=35c50e78&scoped=true"
import script from "./GideViewCurrentEvent.vue?vue&type=script&lang=js"
export * from "./GideViewCurrentEvent.vue?vue&type=script&lang=js"
import style0 from "./GideViewCurrentEvent.vue?vue&type=style&index=0&id=35c50e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c50e78",
  null
  
)

export default component.exports